/**
 * Lightweight logger. In production builds the methods are no-ops so debug
 * output and error details don't leak to end users' browser consoles; in
 * development they behave like the matching console methods.
 */
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  log: (...args) => { if (isDev) console.log(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
};

export default logger;
